import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ResyncIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70039 3V1.125L5.30039 3.625L7.70039 6.125V4.25C9.68639 4.25 11.3004 5.93125 11.3004 8C11.3004 8.63125 11.1504 9.23125 10.8804 9.75L11.7564 10.6625C12.2244 9.89375 12.5004 8.98125 12.5004 8C12.5004 5.2375 10.3524 3 7.70039 3ZM7.70039 11.75C5.71439 11.75 4.10039 10.0687 4.10039 8C4.10039 7.36875 4.25039 6.76875 4.52039 6.25L3.64439 5.3375C3.17639 6.10625 2.90039 7.01875 2.90039 8C2.90039 10.7625 5.04839 13 7.70039 13V14.875L10.1004 12.375L7.70039 9.875V11.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default ResyncIcon;
